import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image, View, Text, StyleSheet } from '@react-pdf/renderer';
import TopRx from '../../../../../images/TopRxLogo.png';
const Header = () => {
    const styles = StyleSheet.create({
        headerContainer: {
            paddingLeft: 8,
            paddingRight: 8,
            paddingBottom: 8,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        headerLeft: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        headerRight: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
        },
        image: {
            width: 100,
        },
        row: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        textRow: {
            flexWrap: 'nowrap',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        headerTextBold: {
            marginRight: 5,
            fontSize: 11,
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            textAlign: 'center',
        },
        headerText: {
            fontSize: 10,
        },
        title: {
            fontSize: 16,
            color: '#137AB1',
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            textAlign: 'center',
            marginLeft: -103,
            marginTop: 5,
            marginBottom: -10,
        },
        table: {
            display: 'table',
            width: '150px',
            borderStyle: 'solid',
            borderColor: '#137AB1',
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0,
        },
        tableRow: {
            width: '150px',
            margin: 'auto',
            flexDirection: 'row',
            borderColor: '#137AB1',
            borderTopWidth: 1,
            borderLeftWidth: 1,
        },
        tableColLeft1: {
            width: '25%',
            borderStyle: 'solid',
            borderColor: '#137AB1',
            borderRightWidth: 1,
        },
        tableColRight1: {
            width: '75%',
        },
        colLeftText: {
            marginLeft: 5,
            marginRight: 5,
            fontSize: 8,
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            textAlign: 'center',
            textTransform: 'uppercase',
        },
        colRightText: {
            fontSize: 9,
            textAlign: 'center',
            marginLeft: 5,
            marginRight: 5,
        },
        tableColLeft2: {
            width: '40%',
            borderStyle: 'solid',
            borderColor: '#137AB1',
            borderRightWidth: 1,
        },
        tableColRight2: {
            width: '60%',
        },
    });
    return (_jsxs(View, { style: styles.headerContainer, children: [_jsxs(View, { style: styles.headerLeft, children: [_jsx(View, { children: _jsx(Image, { style: styles.image, src: TopRx }) }), _jsxs(View, { children: [_jsx(Text, { style: styles.headerText, children: "2950 Brother Blvd." }), _jsx(Text, { style: styles.headerText, children: "Bartlett, TN 38134" }), _jsxs(View, { style: styles.textRow, children: [_jsx(Text, { style: styles.headerTextBold, children: "main:" }), _jsx(Text, { style: styles.headerText, children: "844.334.9465" })] }), _jsxs(View, { style: styles.textRow, children: [_jsx(Text, { style: styles.headerTextBold, children: "credit:" }), _jsx(Text, { style: styles.headerText, children: "855.315.1900" })] }), _jsx(View, { children: _jsx(Text, { style: styles.title, children: "Credit Application" }) })] })] }), _jsxs(View, { style: styles.headerRight, children: [_jsxs(View, { style: styles.table, children: [_jsx(View, { style: styles.tableRow, children: _jsx(Text, { style: { ...styles.headerTextBold, fontSize: 8, margin: 'auto', textAlign: 'center', }, children: "Please return completed form via:" }) }), _jsxs(View, { style: styles.tableRow, children: [_jsx(View, { style: styles.tableColLeft1, children: _jsx(Text, { style: styles.colLeftText, children: "EMAIL" }) }), _jsx(View, { style: styles.tableColRight1, children: _jsx(Text, { style: styles.colRightText, children: "t.whitten@toprx.com" }) })] }), _jsxs(View, { style: styles.tableRow, children: [_jsx(View, { style: styles.tableColLeft1, children: _jsx(Text, { style: styles.colLeftText, children: "FAX" }) }), _jsx(View, { style: styles.tableColRight1, children: _jsx(Text, { style: styles.colRightText, children: "901-842-9295" }) })] }), _jsxs(View, { style: styles.tableRow, children: [_jsx(View, { style: styles.tableColLeft1, children: _jsx(Text, { style: styles.colLeftText, children: "ATTN" }) }), _jsx(View, { style: styles.tableColRight1, children: _jsx(Text, { style: styles.colRightText, children: "Tanner Whitten" }) })] })] }), _jsxs(View, { style: { ...styles.table, marginLeft: 10, width: '170px', }, children: [_jsx(View, { style: { ...styles.tableRow, width: '170px', }, children: _jsx(Text, { style: { ...styles.headerTextBold, fontSize: 8, margin: 'auto', textAlign: 'center', }, children: "ADMIN ONLY" }) }), _jsxs(View, { style: { ...styles.tableRow, width: '170px', }, children: [_jsx(View, { style: styles.tableColLeft2, children: _jsx(Text, { style: styles.colLeftText, children: "AM Name" }) }), _jsx(View, { style: styles.tableColRight2, children: _jsx(Text, { style: styles.colRightText, children: "Tanner Whitten" }) })] }), _jsxs(View, { style: { ...styles.tableRow, width: '170px', }, children: [_jsx(View, { style: styles.tableColLeft2, children: _jsx(Text, { style: styles.colLeftText, children: "Sales #" }) }), _jsx(View, { style: styles.tableColRight2 })] }), _jsxs(View, { style: { ...styles.tableRow, width: '170px', }, children: [_jsx(View, { style: styles.tableColLeft2, children: _jsx(Text, { style: { ...styles.colLeftText, fontSize: 7, }, children: "New Account?" }) }), _jsx(View, { style: { ...styles.tableColRight2, width: '20%', } }), _jsx(View, { style: { ...styles.tableColRight2, width: '20%', borderColor: '#137AB1', borderLeftWidth: 1, borderRightWidth: 1, }, children: _jsx(Text, { style: { ...styles.colLeftText, fontSize: 7, }, children: "Rev?" }) }), _jsx(View, { style: { ...styles.tableColRight2, width: '20%', } })] }), _jsxs(View, { style: { ...styles.tableRow, width: '170px', }, children: [_jsx(View, { style: styles.tableColLeft2, children: _jsx(Text, { style: styles.colLeftText, children: "CRM ID" }) }), _jsx(View, { style: styles.tableColRight2 })] })] })] })] }));
};
export default Header;
